/**
 * Gulf country popup → Beast Currency Converter (Doubly)
 * Popup choice + Doubly bottom-left switcher stay in sync across reloads.
 */
(function () {
  if (window.__perfyraCountryPopup) return;
  window.__perfyraCountryPopup = true;

  var STORAGE_KEY = 'perfyra-gulf-country';
  var STORAGE_DAYS_KEY = 'perfyra-gulf-country-expires';
  var applying = false;

  var CURRENCY_TO_COUNTRY = {
    AED: { country: 'AE', label: 'United Arab Emirates' },
    KWD: { country: 'KW', label: 'Kuwait' },
    QAR: { country: 'QA', label: 'Qatar' },
    BHD: { country: 'BH', label: 'Bahrain' },
    JOD: { country: 'JO', label: 'Jordan' },
    SAR: { country: 'SA', label: 'Saudi Arabia' },
    OMR: { country: 'OM', label: 'Oman' }
  };

  var COUNTRY_TO_CURRENCY = {
    AE: 'AED',
    SA: 'SAR',
    KW: 'KWD',
    QA: 'QAR',
    BH: 'BHD',
    OM: 'OMR',
    JO: 'JOD'
  };

  function setCookie(name, value, days) {
    var maxAge = (days || 365) * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
  }

  /** Beast stores currency as base64 in a private cookie — must be set BEFORE Doubly boots. */
  function writeBeastCookie(currencyCode) {
    var code = String(currencyCode || '').toUpperCase();
    if (!CURRENCY_TO_COUNTRY[code]) return;
    var name = (window.DoublyGlobal && window.DoublyGlobal.cookieName) || '_g1784272901';
    var encoded = '';
    try {
      encoded = btoa(code);
    } catch (e) {
      return;
    }
    var maxAge = 365 * 24 * 60 * 60;
    // No Domain= attribute — host-only cookie works on perfyra.com and www
    document.cookie = name + '=' + encoded + ';path=/;max-age=' + maxAge + ';SameSite=Lax';
    try {
      if (window.DoublyCurrency && window.DoublyCurrency.cookie && typeof window.DoublyCurrency.cookie.write === 'function') {
        window.DoublyCurrency.cookie.write(code);
        window.DoublyCurrency.currentCurrency = code;
      }
    } catch (e2) {}
  }

  function getUrlCurrency() {
    try {
      var raw = new URL(window.location.href).searchParams.get('currency');
      return normalizeCurrency(raw) || '';
    } catch (e) {
      return '';
    }
  }

  function resolveDesiredCurrency() {
    var fromUrl = getUrlCurrency();
    if (fromUrl) return fromUrl;
    var saved = getSavedChoice();
    if (saved && saved.currency) {
      var fromSaved = normalizeCurrency(saved.currency, saved.country, saved.label);
      if (fromSaved) return fromSaved;
    }
    return '';
  }

  /** Force Doubly to re-parse prices (stale doubly-currency attrs can leave AED on screen). */
  function clearDoublyMoneyLocks() {
    try {
      document.querySelectorAll('span.money, .money').forEach(function (el) {
        el.removeAttribute('doubly-currency');
      });
    } catch (e) {}
  }

  function moneyLooksConverted(code) {
    var sample = document.querySelector('span.money, .money');
    if (!sample) return false;
    var text = (sample.textContent || '').toUpperCase();
    return text.indexOf(code) !== -1;
  }

  /** Fix Theme Editor values that were saved as Arabic labels instead of ISO codes. */
  function normalizeCountry(code, label) {
    var raw = String(code || '').trim();
    var up = raw.toUpperCase();
    if (COUNTRY_TO_CURRENCY[up]) return up;

    var hay = (raw + ' ' + String(label || '')).toLowerCase();
    if (/emirates|uae|إمارات/.test(hay)) return 'AE';
    if (/saudi|سعود/.test(hay)) return 'SA';
    if (/kuwait|كويت/.test(hay)) return 'KW';
    if (/qatar|قطر/.test(hay)) return 'QA';
    if (/bahrain|بحرين/.test(hay)) return 'BH';
    if (/oman|عمان|عُمان/.test(hay)) return 'OM';
    if (/jordan|أردن/.test(hay)) return 'JO';
    return '';
  }

  function normalizeCurrency(code, countryCode, label) {
    var raw = String(code || '').trim();
    var up = raw.toUpperCase();
    if (CURRENCY_TO_COUNTRY[up]) return up;

    var hay = (raw + ' ' + String(label || '')).toLowerCase();
    if (/aed|درهم|إمارات/.test(hay)) return 'AED';
    if (/sar|سعود/.test(hay)) return 'SAR';
    if (/kwd|كويت|د\.ك/.test(hay)) return 'KWD';
    if (/qar|قطر/.test(hay)) return 'QAR';
    if (/bhd|بحرين/.test(hay)) return 'BHD';
    if (/omr|عمان|عُمان/.test(hay)) return 'OMR';
    if (/jod|أردن/.test(hay)) return 'JOD';

    var country = normalizeCountry(countryCode, label);
    if (country && COUNTRY_TO_CURRENCY[country]) return COUNTRY_TO_CURRENCY[country];
    return '';
  }

  function getDoublySelect() {
    return document.querySelector('select.currency-switcher[name="doubly-currencies"]')
      || document.querySelector('select.currency-switcher')
      || document.querySelector('.doubly-float select')
      || document.querySelector('.doubly-wrapper select');
  }

  function readDoublyCurrency() {
    try {
      if (window.DoublyCurrency && window.DoublyCurrency.cookie && typeof window.DoublyCurrency.cookie.read === 'function') {
        var fromCookie = window.DoublyCurrency.cookie.read();
        if (fromCookie && fromCookie !== 'undefined') return String(fromCookie).toUpperCase();
      }
    } catch (e) {}

    try {
      if (window.DoublyCurrency && window.DoublyCurrency.currentCurrency) {
        return String(window.DoublyCurrency.currentCurrency).toUpperCase();
      }
    } catch (e) {}

    var select = getDoublySelect();
    if (select && select.value) return String(select.value).toUpperCase();

    var selected = document.querySelector('.doubly-nice-select .option.selected');
    if (selected && selected.getAttribute('data-value')) {
      return String(selected.getAttribute('data-value')).toUpperCase();
    }

    return '';
  }

  function rememberCurrency(currencyCode, days) {
    var code = String(currencyCode || '').toUpperCase();
    if (!code) return;
    var meta = CURRENCY_TO_COUNTRY[code] || { country: code.slice(0, 2), label: code };
    var existing = getSavedChoice();
    var keepDays = typeof days === 'number' ? days : 30;
    if (existing && existing.currency === code) {
      // refresh timestamp only
      saveChoice(meta.country, code, keepDays, existing.label || meta.label);
      return;
    }
    saveChoice(meta.country, code, keepDays, meta.label);
  }

  function triggerDoublyConvert() {
    try {
      if (typeof window.doublyChangeEvent === 'function') {
        window.doublyChangeEvent();
      }
    } catch (e) {}
  }

  function setDoublyCurrency(currencyCode) {
    if (!currencyCode) return false;
    var code = normalizeCurrency(currencyCode) || String(currencyCode).toUpperCase();
    if (!CURRENCY_TO_COUNTRY[code]) return false;

    applying = true;
    writeBeastCookie(code);

    setCookie('currency', code, 365);
    setCookie('cart_currency', code, 365);
    setCookie('doubly_currency', code, 365);
    setCookie('doublyCurrency', code, 365);
    try {
      localStorage.setItem('currency', code);
      localStorage.setItem('doubly_currency', code);
      localStorage.setItem('doublyCurrency', code);
      sessionStorage.setItem('currency', code);
    } catch (e) {}

    // Wait until Beast rates are loaded — convertAll cannot change prices before that.
    if (!window.DoublyCurrency || typeof window.DoublyCurrency.convertAll !== 'function' || !window.DoublyCurrency.rates) {
      applying = false;
      return false;
    }

    var applied = false;
    var select = getDoublySelect();

    // Keep Doubly float in DOM while converting; pin above mobile dock (do not off-screen)
    var hiddenHosts = document.querySelectorAll('.doubly-float, .doubly-wrapper');
    var prevStyles = [];
    Array.prototype.forEach.call(hiddenHosts, function (el, i) {
      prevStyles[i] = el.getAttribute('style') || '';
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('left', '10px', 'important');
      el.style.setProperty('right', 'auto', 'important');
      el.style.setProperty('bottom', 'calc(var(--pmd-height, 72px) + 28px + env(safe-area-inset-bottom, 0px))', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('pointer-events', 'auto', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('z-index', '45', 'important');
    });

    if (select) {
      var hasOption = false;
      Array.prototype.forEach.call(select.options || [], function (opt) {
        if (String(opt.value || '').toUpperCase() === code) hasOption = true;
      });
      if (hasOption) {
        select.value = code;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.jQueryGrizzly) {
          try { window.jQueryGrizzly(select).val(code).trigger('change'); } catch (e) {}
        }
        if (window.jQuery) {
          try { window.jQuery(select).val(code).trigger('change'); } catch (e) {}
        }
        applied = true;
      }
    }

    document.querySelectorAll('.doubly-nice-select .option').forEach(function (opt) {
      var val = String(opt.getAttribute('data-value') || '').toUpperCase();
      opt.classList.toggle('selected', val === code);
    });

    document.querySelectorAll('.doubly-nice-select').forEach(function (wrap) {
      var current = wrap.querySelector('.current');
      var selected = wrap.querySelector('.option.selected, .option[data-value="' + code + '"]');
      if (current && selected) current.innerHTML = selected.innerHTML;
    });

    try {
      window.DoublyCurrency.currentCurrency = code;
      if (window.DoublyCurrency.cookie && typeof window.DoublyCurrency.cookie.write === 'function') {
        window.DoublyCurrency.cookie.write(code);
      }
      clearDoublyMoneyLocks();
      window.DoublyCurrency.convertAll(code);
      applied = true;
    } catch (e) {}

    try {
      if (window.Currency && typeof window.Currency.convertAll === 'function' && window.Currency !== window.DoublyCurrency) {
        var shopCurrency = (window.DoublyGlobal && window.DoublyGlobal.shopCurrency)
          || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
          || 'AED';
        window.Currency.currentCurrency = code;
        window.Currency.convertAll(shopCurrency, code);
        applied = true;
      }
    } catch (e) {}

    try {
      if (window.DoublyGlobal) window.DoublyGlobal.currentCurrency = code;
    } catch (e) {}

    triggerDoublyConvert();
    rememberCurrency(code);

    try {
      document.dispatchEvent(new CustomEvent('perfyra:country-changed', {
        bubbles: true,
        detail: {
          currency: code,
          country: (CURRENCY_TO_COUNTRY[code] && CURRENCY_TO_COUNTRY[code].country) || ''
        }
      }));
    } catch (e3) {}

    try {
      if (typeof window.PerfyraConvertPrices === 'function') {
        window.PerfyraConvertPrices(code);
        applied = true;
      }
    } catch (e) {}

    Array.prototype.forEach.call(hiddenHosts, function (el, i) {
      if (prevStyles[i]) el.setAttribute('style', prevStyles[i]);
      else el.removeAttribute('style');
    });

    setTimeout(function () { applying = false; }, 300);

    // Only treat as success once a visible price shows the target currency.
    if (moneyLooksConverted(code)) return true;
    return applied && !!window.DoublyCurrency.rates;
  }

  function waitForDoublyThenSet(currencyCode, tries) {
    tries = typeof tries === 'number' ? tries : 40;
    var code = normalizeCurrency(currencyCode) || String(currencyCode || '').toUpperCase();
    if (!CURRENCY_TO_COUNTRY[code]) return;
    writeBeastCookie(code);
    if (setDoublyCurrency(code) && moneyLooksConverted(code)) return;
    if (tries <= 0) return;
    setTimeout(function () {
      waitForDoublyThenSet(code, tries - 1);
    }, 350);
  }

  function keepCurrencyApplied(currencyCode) {
    var code = normalizeCurrency(currencyCode) || String(currencyCode || '').toUpperCase();
    if (!CURRENCY_TO_COUNTRY[code]) return;
    writeBeastCookie(code);
    waitForDoublyThenSet(code);
    var n = 0;
    var timer = setInterval(function () {
      n += 1;
      if (!moneyLooksConverted(code)) {
        clearDoublyMoneyLocks();
        setDoublyCurrency(code);
      }
      if (n >= 12) clearInterval(timer);
    }, 1000);
  }

  function submitShopifyCountry(countryCode, root) {
    if (!countryCode) return false;
    var code = String(countryCode).toUpperCase();

    var form = (root && root.querySelector('.perfyra-country-popup__localization-form'))
      || document.querySelector('.perfyra-country-popup__localization-form')
      || document.querySelector('form[action*="/localization"]')
      || document.getElementById('localization_form');

    if (!form) return false;

    var input = form.querySelector('[name="country_code"]') || document.getElementById('perfyra-country-code');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'country_code';
      form.appendChild(input);
    }

    var localeInput = form.querySelector('[name="locale_code"]');
    if (!localeInput) {
      localeInput = document.createElement('input');
      localeInput.type = 'hidden';
      localeInput.name = 'locale_code';
      localeInput.value = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
      form.appendChild(localeInput);
    }

    if ((input.value || '').toUpperCase() === code) return false;
    input.value = code;
    form.submit();
    return true;
  }

  function saveChoice(countryCode, currencyCode, days, label) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        country: countryCode,
        currency: currencyCode,
        label: label || countryCode,
        at: Date.now()
      }));
      if (days > 0) {
        localStorage.setItem(STORAGE_DAYS_KEY, String(Date.now() + days * 86400000));
      } else {
        localStorage.removeItem(STORAGE_DAYS_KEY);
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('perfyra:country-changed', {
        bubbles: true,
        detail: { country: countryCode, currency: currencyCode, label: label || countryCode }
      }));
    } catch (e2) {}
  }

  function isChoiceExpired() {
    try {
      var expires = localStorage.getItem(STORAGE_DAYS_KEY);
      if (!expires) return !localStorage.getItem(STORAGE_KEY);
      return Date.now() > Number(expires);
    } catch (e) {
      return true;
    }
  }

  function getSavedChoice() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data) return null;
      var country = normalizeCountry(data.country, data.label);
      var currency = normalizeCurrency(data.currency, country || data.country, data.label);
      if (country) data.country = country;
      if (currency) data.currency = currency;
      if (!data.country || !data.currency) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function isHoldingSignup() {
    return document.documentElement.classList.contains('perfyra-hold-signup-popup')
      || document.documentElement.classList.contains('perfyra-country-popup-open')
      || !!document.querySelector('.perfyra-country-popup.is-open');
  }

  function usesThemeSignupPopup() {
    return document.documentElement.classList.contains('perfyra-use-theme-signup')
      || !!document.querySelector('.section-pf-signup-popup, .pf-signup-popup');
  }

  function shouldSuppressExternalSignup() {
    return isHoldingSignup() || usesThemeSignupPopup();
  }

  function syncReopenFlag(root, countryCode, fromBtn) {
    var reopen = root && root.querySelector('[data-pcp-reopen]');
    if (!reopen) return;
    var wrap = reopen.querySelector('[data-pcp-reopen-flag-wrap]');
    if (!wrap) return;
    var source = null;
    if (fromBtn) {
      source = fromBtn.querySelector('[data-country-flag]');
    }
    if (!source && countryCode) {
      source = root.querySelector('[data-pcp-country][data-country="' + String(countryCode).toUpperCase() + '"] [data-country-flag]');
    }
    if (source) {
      wrap.innerHTML = source.outerHTML;
      var cloned = wrap.querySelector('[data-country-flag]');
      if (cloned) cloned.className = 'perfyra-country-popup__flag-svg';
    }
  }

  function closePopup(root, fromBtn) {
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('perfyra-country-popup-open');
    var overlay = root.querySelector('[data-pcp-overlay]');
    if (overlay) overlay.hidden = true;
    var reopen = root.querySelector('[data-pcp-reopen]');
    if (reopen && root.getAttribute('data-show-reopen') === 'true') {
      reopen.hidden = false;
      var saved = getSavedChoice();
      if (saved) {
        var label = reopen.querySelector('[data-pcp-reopen-label]');
        if (label && saved.label) label.textContent = saved.label;
        syncReopenFlag(root, saved.country, fromBtn || null);
      }
    }
    // Only release signup AFTER country is chosen/closed
    notifyCountryReady();
  }

  function openPopup(root) {
    if (!root) return;
    root.classList.add('is-open');
    document.documentElement.classList.add('perfyra-country-popup-open');
    document.documentElement.classList.add('perfyra-hold-signup-popup');
    window.__perfyraCountryReady = false;
    var overlay = root.querySelector('[data-pcp-overlay]');
    if (overlay) overlay.hidden = false;
    var reopen = root.querySelector('[data-pcp-reopen]');
    if (reopen) reopen.hidden = true;
    forceHideOfferPopups();
  }

  function pick(btn) {
    var root = btn.closest('[data-perfyra-country-popup]');
    if (!root) return;

    var label = btn.getAttribute('data-label') || '';
    var country = normalizeCountry(btn.getAttribute('data-country'), label);
    var currency = normalizeCurrency(btn.getAttribute('data-currency'), country, label);
    if (!country) country = 'AE';
    if (!currency) currency = COUNTRY_TO_CURRENCY[country] || 'AED';
    label = label || (CURRENCY_TO_COUNTRY[currency] && CURRENCY_TO_COUNTRY[currency].label) || country;

    // Keep DOM attrs clean for reopen / future picks
    btn.setAttribute('data-country', country);
    btn.setAttribute('data-currency', currency);

    var days = Number(root.getAttribute('data-reappear-days') || 30);
    var useMarkets = root.getAttribute('data-use-markets') === 'true';

    root.querySelectorAll('[data-pcp-country]').forEach(function (el) {
      el.classList.toggle('is-active', el === btn);
    });

    // Cookie FIRST so Beast reads JOD/KWD/… on the next page load
    writeBeastCookie(currency);
    saveChoice(country, currency, days, label);
    setDoublyCurrency(currency);
    try {
      if (typeof window.PerfyraConvertPrices === 'function') window.PerfyraConvertPrices(currency);
    } catch (e) {}
    keepCurrencyApplied(currency);
    closePopup(root, btn);

    var hasDoubly = !!(
      window.DoublyCurrency
      || window.Currency
      || getDoublySelect()
      || document.querySelector('[class*="doubly"], [id*="doubly"]')
    );

    // Markets + Doubly fight (prices stay AED). Prefer Doubly, then reload so all prices convert.
    if (useMarkets && !hasDoubly) {
      setTimeout(function () {
        submitShopifyCountry(country, root);
      }, 250);
      return;
    }

    setTimeout(function () {
      writeBeastCookie(currency);
      setDoublyCurrency(currency);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('currency', currency);
        url.searchParams.set('pb', '0');
        window.location.replace(url.toString());
      } catch (e) {
        window.location.reload();
      }
    }, 600);
  }

  function skip(root) {
    var btn = root.querySelector('[data-pcp-country][data-country="AE"]') || root.querySelector('[data-pcp-country]');
    if (btn) {
      pick(btn);
      return;
    }
    saveChoice('AE', 'AED', Number(root.getAttribute('data-reappear-days') || 30), 'United Arab Emirates');
    waitForDoublyThenSet('AED');
    closePopup(root);
  }

  function onManualCurrencyChange(currencyCode) {
    if (applying) return;
    var code = String(currencyCode || '').toUpperCase();
    if (!code || !CURRENCY_TO_COUNTRY[code]) return;
    var meta = CURRENCY_TO_COUNTRY[code];
    var root = document.querySelector('[data-perfyra-country-popup]');
    var days = root ? Number(root.getAttribute('data-reappear-days') || 30) : 30;
    rememberCurrency(code, days);
    try {
      document.documentElement.setAttribute('data-perfyra-currency', code);
    } catch (e) {}
    try {
      if (typeof window.PerfyraConvertPrices === 'function') {
        window.PerfyraConvertPrices(code);
      }
    } catch (e2) {}
    try {
      document.dispatchEvent(new CustomEvent('perfyra:country-changed', {
        bubbles: true,
        detail: {
          currency: code,
          country: meta.country || ''
        }
      }));
    } catch (e3) {}
    if (root && meta) {
      syncReopenFlag(root, meta.country);
      var reopen = root.querySelector('[data-pcp-reopen]');
      var label = reopen && reopen.querySelector('[data-pcp-reopen-label]');
      if (label) label.textContent = meta.label || code;
    }
  }

  function bindDoublySwitcherSync() {
    if (window.__perfyraDoublySyncBound) return;
    window.__perfyraDoublySyncBound = true;

    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.matches) return;
      if (!el.matches('select.currency-switcher, select[name="doubly-currencies"]')) return;
      onManualCurrencyChange(el.value);
    }, true);

    document.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest && e.target.closest('.doubly-nice-select .option');
      if (!opt) return;
      onManualCurrencyChange(opt.getAttribute('data-value'));
    }, true);

    document.addEventListener('currency:change', function (e) {
      if (e && e.detail && e.detail.currency) onManualCurrencyChange(e.detail.currency);
    });
    document.addEventListener('doubly:currency:change', function (e) {
      if (e && e.detail && e.detail.currency) onManualCurrencyChange(e.detail.currency);
    });
  }

  var DOUBLY_LAYOUT_CSS = [
    '.doubly-float .doubly-nice-select .list,',
    '.doubly-wrapper .doubly-nice-select .list{',
   'width:max-content!important;',
'min-width:320px!important;',
'max-width:calc(100vw - 24px)!important;',
    'box-sizing:border-box!important;}',
    '.doubly-float .doubly-nice-select .list>.option,',
    '.doubly-wrapper .doubly-nice-select .list>.option{',
    'display:flex!important;',
    'align-items:center!important;',
    'justify-content:flex-start!important;',
    'gap:10px!important;',
    'direction:ltr!important;',
    'unicode-bidi:isolate!important;',
    'text-align:left!important;',
    'text-indent:0!important;',
    'white-space:nowrap!important;',
    'height:40px!important;',
    'line-height:40px!important;',
    'padding:0 16px!important;',
    'overflow:hidden!important;}',
    '.doubly-float .doubly-nice-select .list>.option>.flags,',
    '.doubly-wrapper .doubly-nice-select .list>.option>.flags{',
    'display:block!important;',
    'float:none!important;',
    'position:static!important;',
    'flex:0 0 32px!important;',
    'width:32px!important;',
    'min-width:32px!important;',
    'max-width:32px!important;',
    'height:22px!important;',
    'margin:0!important;}',
    '.doubly-float .doubly-nice-select .list>.option>.perfyra-doubly-label,',
    '.doubly-wrapper .doubly-nice-select .list>.option>.perfyra-doubly-label{',
    'display:block!important;',
    'min-width:0!important;',
    'overflow:hidden!important;',
    'text-overflow:ellipsis!important;',
    'direction:ltr!important;',
    'unicode-bidi:isolate!important;}',
    '.doubly-float .doubly-nice-select .current,',
    '.doubly-wrapper .doubly-nice-select .current{',
    'display:flex!important;',
    'align-items:center!important;',
    'gap:8px!important;',
    'direction:ltr!important;',
    'unicode-bidi:isolate!important;}',
    '.doubly-float .doubly-nice-select .current>.flags,',
    '.doubly-wrapper .doubly-nice-select .current>.flags{',
    'float:none!important;',
    'margin:0!important;',
    'flex:0 0 32px!important;}'
  ].join('');

  function injectDoublyLayoutStyle() {
    try {
      if (document.getElementById('perfyra-doubly-layout-style')) return;
      var style = document.createElement('style');
      style.id = 'perfyra-doubly-layout-style';
      style.textContent = DOUBLY_LAYOUT_CSS;
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  }

  function wrapDoublyTextNodes(root) {
    try {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.doubly-nice-select .list > .option, .doubly-nice-select .current').forEach(function (el) {
        if (el.querySelector('.perfyra-doubly-label')) return;
        Array.prototype.slice.call(el.childNodes || []).forEach(function (node) {
          if (node.nodeType !== 3) return;
          var text = String(node.nodeValue || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
          if (!text) {
            node.nodeValue = '';
            return;
          }
          var label = document.createElement('span');
          label.className = 'perfyra-doubly-label';
          label.textContent = text;
          el.replaceChild(label, node);
        });
      });
    } catch (e) {}
  }

  function startDoublyLayoutWatcher() {
    injectDoublyLayoutStyle();
    wrapDoublyTextNodes(document);
    setTimeout(function () { wrapDoublyTextNodes(document); }, 400);
    setTimeout(function () { wrapDoublyTextNodes(document); }, 1200);
    if (window.__perfyraDoublyLayoutWatcher) return;
    window.__perfyraDoublyLayoutWatcher = true;
    try {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.addedNodes && record.addedNodes.length) {
            wrapDoublyTextNodes(record.target || document);
          }
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-pcp-ready') === '1') return;
    root.setAttribute('data-pcp-ready', '1');

    var delay = Number(root.getAttribute('data-delay') || 1);
    var designMode = root.getAttribute('data-design-mode') === 'true';
    var saved = getSavedChoice();

    root.addEventListener('click', function (e) {
      var countryBtn = e.target.closest('[data-pcp-country]');
      if (countryBtn && root.contains(countryBtn)) {
        e.preventDefault();
        e.stopPropagation();
        pick(countryBtn);
        return;
      }
      if (e.target.closest('[data-pcp-skip]')) {
        e.preventDefault();
        skip(root);
        return;
      }
      if (e.target.closest('[data-pcp-reopen]')) {
        e.preventDefault();
        openPopup(root);
        return;
      }
      if (e.target.matches('[data-pcp-overlay]') && root.getAttribute('data-allow-dismiss') === 'true') {
        skip(root);
      }
    });

    if (designMode) {
      openPopup(root);
      return;
    }

    if (!saved || isChoiceExpired()) {
      setTimeout(function () { openPopup(root); }, Math.max(0, delay) * 1000);
      startOfferHoldWatcher();
    } else {
      closePopup(root);
    }

    // Always drive Beast from URL (?currency=JOD) or saved choice — this is what updates product prices.
    var desired = resolveDesiredCurrency();
    if (desired) {
      writeBeastCookie(desired);
      keepCurrencyApplied(desired);
    }
  }

  /** Detect Shopify Forms / signup modal nodes */
  function looksLikeSignupModal(el) {
    if (!el || el.nodeType !== 1) return false;
    // Never treat theme popups / eurus portal as external Forms
    if (el.id === 'eurus-popup') return false;
    if (el.closest && el.closest('#eurus-popup')) return false;
    if (el.closest && el.closest('[data-perfyra-country-popup]')) return false;
    if (el.closest && el.closest('.pf-signup-popup, .section-pf-signup-popup, [id^="x-pf-signup-popup"]')) return false;
    if (el.querySelector && el.querySelector('.pf-signup-popup, [id^="x-pf-signup-popup"], .section-pf-signup-popup')) return false;
    if (el.getAttribute && el.getAttribute('data-perfyra-country-popup') != null) return false;
    if (el.classList && el.classList.contains('perfyra-country-popup__overlay')) return false;
    if (el.classList && el.classList.contains('perfyra-country-popup__dialog')) return false;
    if (el.classList && (el.classList.contains('pf-signup-popup') || el.classList.contains('section-pf-signup-popup'))) return false;
    var id = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : (el.className && el.className.baseVal) || '');
    if (/shopify-forms|ShopifyForms|shopify-email|email-signup|forms-modal|form-modal|FormsEmbed|forms-embed/i.test(id)) return true;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length > 4000) return false;
    var hasOffer = /Sign up and save|سجل ووفر|سجّل ووفر|Get 10%|احصل على خصم|Continue with Shop|shop Continue with/i.test(text);
    var hasEmail = /البريد الإلكتروني|Email|type="email"/i.test(text) || !!(el.querySelector && el.querySelector('input[type="email"]'));
    var isOldArabicSignup = (/^\s*سجل\b/.test(text) || /احصل على خصم\s*10%/i.test(text)) && hasEmail;
    return hasOffer || isOldArabicSignup || (hasEmail && /Continue with|سجل|Submit|or/i.test(text) && text.length < 2500);
  }

  function hideNodeHard(el) {
    if (!el || !el.style) return;
    el.setAttribute('data-perfyra-signup-modal', '1');
    el.setAttribute('data-perfyra-signup-held', '1');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('z-index', '-1', 'important');
  }

  function findFixedAncestor(el) {
    var cur = el;
    var depth = 0;
    while (cur && cur !== document.body && depth < 12) {
      try {
        var cs = window.getComputedStyle(cur);
        if (cs && (cs.position === 'fixed' || cs.position === 'sticky')) return cur;
      } catch (e) {}
      cur = cur.parentElement;
      depth += 1;
    }
    return el;
  }

  /** Aggressively hide Shopify Forms / external signup when held or theme popup is active */
  function forceHideOfferPopups() {
    if (!shouldSuppressExternalSignup()) return;
    if (isHoldingSignup()) document.documentElement.classList.add('perfyra-hold-signup-popup');
    if (usesThemeSignupPopup()) document.documentElement.classList.add('perfyra-use-theme-signup');

    var nodes = document.body ? document.body.querySelectorAll('div, section, aside, dialog, form') : [];
    Array.prototype.forEach.call(nodes, function (el) {
      if (!looksLikeSignupModal(el)) return;
      var target = findFixedAncestor(el) || el;
      // Prefer outermost signup container among body children
      if (target.parentElement === document.body) {
        hideNodeHard(target);
      } else if (el.parentElement === document.body) {
        hideNodeHard(el);
      } else {
        hideNodeHard(target);
      }
    });

    Array.prototype.forEach.call(document.body.children || [], function (el) {
      if (el.matches && el.matches('[data-perfyra-country-popup], script, style, link, meta')) return;
      if (looksLikeSignupModal(el)) hideNodeHard(el);
    });
  }

  function markAndHoldSignupModals(root) {
    if (!shouldSuppressExternalSignup()) return;
    forceHideOfferPopups();
    if (!root || root === document || root === document.body) return;
    if (looksLikeSignupModal(root)) hideNodeHard(findFixedAncestor(root) || root);
    try {
      root.querySelectorAll && root.querySelectorAll('div, section, dialog, form').forEach(function (el) {
        if (looksLikeSignupModal(el)) hideNodeHard(findFixedAncestor(el) || el);
      });
    } catch (e) {}
  }

  function releaseSignupModals() {
    // Keep Shopify Forms suppressed when the Perfyra theme signup popup is active
    if (usesThemeSignupPopup()) {
      document.documentElement.classList.add('perfyra-use-theme-signup');
      forceHideOfferPopups();
      return;
    }
    document.querySelectorAll('[data-perfyra-signup-held], [data-perfyra-signup-modal]').forEach(function (el) {
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('pointer-events');
      el.style.removeProperty('z-index');
      el.removeAttribute('data-perfyra-signup-held');
    });
  }

  function startOfferHoldWatcher() {
    if (window.__perfyraOfferHoldTimer) return;
    forceHideOfferPopups();
    // Slow backup only — MutationObserver handles new signup nodes
    window.__perfyraOfferHoldTimer = setInterval(function () {
      if (!shouldSuppressExternalSignup()) {
        clearInterval(window.__perfyraOfferHoldTimer);
        window.__perfyraOfferHoldTimer = null;
        return;
      }
      forceHideOfferPopups();
    }, 2000);
  }

  var EMAIL_RTL_CSS = [
    'input[type="email"],input[type="text"][inputmode="email"],input[data-perfyra-email-rtl],input[placeholder*="بريد"]{',
    'direction:rtl!important;text-align:right!important;unicode-bidi:isolate!important;}',
    'input[type="email"]::placeholder,input[type="text"][inputmode="email"]::placeholder,',
    'input[data-perfyra-email-rtl]::placeholder,input[placeholder*="بريد"]::placeholder{',
    'direction:rtl!important;text-align:right!important;unicode-bidi:isolate!important;}'
  ].join('');

  function injectEmailRtlStyle(scope) {
    try {
      var doc = scope.nodeType === 9 ? scope : (scope.ownerDocument || scope);
      var host = scope.nodeType === 11 ? scope : (doc.head || doc.documentElement || scope);
      if (!host || !host.querySelector) return;
      if (host.querySelector('style[data-perfyra-email-rtl-style]')) return;
      var style = (doc.createElement ? doc : document).createElement('style');
      style.setAttribute('data-perfyra-email-rtl-style', '1');
      style.textContent = EMAIL_RTL_CSS;
      host.appendChild(style);
    } catch (e) {}
  }

  function forceEmailInputsRtl(root) {
    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || '';
    if (!/^ar/i.test(String(locale))) return;

    var applyOne = function (input) {
      if (!input || input.nodeType !== 1) return;
      // type=email is forced LTR by browsers — switch to text so Arabic placeholder can sit on the right
      if (input.type === 'email') {
        try {
          input.setAttribute('data-perfyra-was-email', '1');
          input.setAttribute('inputmode', 'email');
          input.setAttribute('autocomplete', input.getAttribute('autocomplete') || 'email');
          input.type = 'text';
        } catch (e) {}
      }
      input.setAttribute('dir', 'rtl');
      input.setAttribute('lang', 'ar');
      input.setAttribute('data-perfyra-email-rtl', '1');
      input.style.setProperty('direction', 'rtl', 'important');
      input.style.setProperty('text-align', 'right', 'important');
      input.style.setProperty('unicode-bidi', 'isolate', 'important');
      var ph = input.getAttribute('placeholder') || '';
      if (!ph || /^\s*email\s*$/i.test(ph) || /email address/i.test(ph)) {
        ph = 'البريد الإلكتروني';
      }
      // RLM ensures Arabic placeholder paints right-to-left even if UA resets dir
      if (ph.charAt(0) !== '\u200F') ph = '\u200F' + ph;
      input.setAttribute('placeholder', ph);
    };

    var scan = function (scope) {
      if (!scope || !scope.querySelectorAll) return;
      injectEmailRtlStyle(scope);
      var inputs = [];
      try {
        inputs = scope.querySelectorAll('input[type="email"], input[type="text"][inputmode="email"], input[name*="email"], input[placeholder], input[data-perfyra-email-rtl]');
      } catch (e) {
        inputs = scope.querySelectorAll('input');
      }
      Array.prototype.forEach.call(inputs, function (input) {
        var name = (input.getAttribute('name') || '') + (input.getAttribute('id') || '') + (input.getAttribute('placeholder') || '') + (input.getAttribute('autocomplete') || '');
        var isEmailField = input.type === 'email'
          || input.getAttribute('inputmode') === 'email'
          || input.getAttribute('data-perfyra-email-rtl') === '1'
          || /email|بريد|إلكتروني|الكتروني/i.test(name);
        if (!isEmailField) return;
        applyOne(input);
      });
      // Only check shadow roots on known form hosts (not every element on the page)
      try {
        Array.prototype.forEach.call(scope.querySelectorAll('[id*="shopify-forms"], [class*="shopify-forms"], [data-forms-id], [data-perfyra-signup-modal]'), function (el) {
          if (el.shadowRoot) {
            injectEmailRtlStyle(el.shadowRoot);
            scan(el.shadowRoot);
          }
        });
      } catch (e) {}
    };

    scan(root && root.querySelectorAll ? root : document);

    // Same-origin iframes (some Forms embeds) — only when scanning full document
    if (!root || root === document || root === document.body) {
      try {
        Array.prototype.forEach.call(document.querySelectorAll('iframe'), function (frame) {
          try {
            var doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
            if (doc) scan(doc);
          } catch (e) {}
        });
      } catch (e) {}
    }
  }

  function startEmailRtlWatcher() {
    var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
    if (!/^ar/i.test(String(locale))) return;
    if (window.__perfyraEmailRtlStarted) return;
    window.__perfyraEmailRtlStarted = true;
    forceEmailInputsRtl(document);
    // One delayed pass for late Shopify Forms inject — no perpetual 400ms full-DOM scan
    setTimeout(function () { forceEmailInputsRtl(document); }, 1500);
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('input')) {
        forceEmailInputsRtl(e.target.parentNode || document);
      }
    }, true);
  }

  function styleSignupModalArabic(el) {
    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || '';
    if (!/^ar/i.test(String(locale)) || !el) return;
    el.setAttribute('dir', 'rtl');
    el.style.setProperty('direction', 'rtl', 'important');
    el.style.setProperty('text-align', 'right', 'important');
    el.style.setProperty('font-family', 'var(--font-body-family), sans-serif', 'important');
    forceEmailInputsRtl(el);
    el.querySelectorAll('input, textarea').forEach(function (input) {
      input.setAttribute('dir', 'rtl');
      input.style.setProperty('direction', 'rtl', 'important');
      input.style.setProperty('text-align', 'right', 'important');
    });
  }

  /** Translate Shopify Forms / signup popup copy on Arabic storefronts */
  function translateSignupPopupArabic(root) {
    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || '';
    if (!/^ar/i.test(String(locale))) return;
    var map = [
      ['Sign up and save', 'سجّل واحفظ'],
      ['shop Continue with', 'المتابعة عبر Shop'],
      ['Continue with Shop', 'المتابعة عبر Shop'],
      ['Continue with', 'المتابعة عبر'],
      ['Get 10% off on your first order', 'احصل على خصم ١٠٪ على طلبك الأول'],
      ['Submit', 'إرسال'],
      ['Email', 'البريد الإلكتروني']
    ];
    var walk = function (node) {
      if (!node) return;
      if (node.nodeType === 3) {
        var text = node.nodeValue;
        if (!text || !text.trim()) return;
        // Standalone "or" / "Or"
        if (/^\s*or\s*$/i.test(text)) {
          node.nodeValue = text.replace(/or/i, 'أو');
          return;
        }
        var next = text;
        map.forEach(function (pair) {
          if (next.indexOf(pair[0]) !== -1) next = next.split(pair[0]).join(pair[1]);
        });
        if (next !== text) node.nodeValue = next;
        return;
      }
      if (node.nodeType !== 1) return;
      var tag = (node.tagName || '').toLowerCase();
      if (tag === 'script' || tag === 'style' || tag === 'noscript') return;
      if (node.shadowRoot) walk(node.shadowRoot);
      if (node.getAttribute && node.getAttribute('placeholder')) {
        var ph = node.getAttribute('placeholder');
        if (/^\s*email\s*$/i.test(ph)) node.setAttribute('placeholder', 'البريد الإلكتروني');
        map.forEach(function (pair) {
          if (ph.indexOf(pair[0]) !== -1) {
            node.setAttribute('placeholder', ph.split(pair[0]).join(pair[1]));
          }
        });
      }
      if (node.getAttribute && node.getAttribute('aria-label')) {
        var al = node.getAttribute('aria-label');
        if (/^\s*or\s*$/i.test(al)) node.setAttribute('aria-label', 'أو');
        map.forEach(function (pair) {
          if (al.indexOf(pair[0]) !== -1) {
            node.setAttribute('aria-label', al.split(pair[0]).join(pair[1]));
          }
        });
      }
      Array.prototype.forEach.call(node.childNodes || [], walk);
    };
    walk(root || document.body);
    forceEmailInputsRtl(root || document.body);
    // Buttons / labels that split text across nodes
    var scope = root && root.querySelectorAll ? root : document;
    try {
      scope.querySelectorAll('button, a, [role="button"], span, p, div, label').forEach(function (el) {
        if (el.children && el.children.length > 3) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^or$/i.test(t)) {
          el.textContent = 'أو';
          return;
        }
        if (/continue with/i.test(t) && t.length < 40) {
          el.textContent = 'المتابعة عبر Shop';
        }
      });
    } catch (e) {}
    document.querySelectorAll('[data-perfyra-signup-modal]').forEach(styleSignupModalArabic);
  }

  function watchSignupPopupArabic() {
    startOfferHoldWatcher();
    markAndHoldSignupModals(document);
    translateSignupPopupArabic(document.body);
    forceEmailInputsRtl(document);
    if (window.__perfyraSignupObs) return;
    window.__perfyraSignupObs = new MutationObserver(function (mutations) {
      var suppress = shouldSuppressExternalSignup();
      var needEmail = false;
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes || [], function (n) {
          if (n.nodeType !== 1) return;
          if (suppress) {
            markAndHoldSignupModals(n);
            if (looksLikeSignupModal(n)) {
              hideNodeHard(findFixedAncestor(n) || n);
              styleSignupModalArabic(n);
            }
          }
          needEmail = true;
          if (!suppress) translateSignupPopupArabic(n);
        });
      });
      if (needEmail) forceEmailInputsRtl(document);
    });
    window.__perfyraSignupObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function notifyCountryReady() {
    if (window.__perfyraCountryReady) return;
    // Never release while country popup is still open
    if (document.querySelector('.perfyra-country-popup.is-open')) return;
    window.__perfyraCountryReady = true;
    try {
      document.documentElement.classList.remove('perfyra-hold-signup-popup');
      document.documentElement.classList.remove('perfyra-country-popup-open');
    } catch (e) {}
    // Keep Forms watcher alive when theme signup replaces Shopify Forms
    if (!usesThemeSignupPopup() && window.__perfyraOfferHoldTimer) {
      clearInterval(window.__perfyraOfferHoldTimer);
      window.__perfyraOfferHoldTimer = null;
    }
    releaseSignupModals();
    if (usesThemeSignupPopup()) startOfferHoldWatcher();
    try {
      document.dispatchEvent(new CustomEvent('perfyra:country-ready', { bubbles: true }));
    } catch (e) {}
    setTimeout(function () {
      releaseSignupModals();
      if (!usesThemeSignupPopup()) {
        translateSignupPopupArabic(document.body);
        forceEmailInputsRtl(document);
        document.querySelectorAll('[data-perfyra-signup-modal]').forEach(styleSignupModalArabic);
      }
    }, 200);
    setTimeout(function () {
      translateSignupPopupArabic(document.body);
      forceEmailInputsRtl(document);
    }, 800);
    setTimeout(function () {
      translateSignupPopupArabic(document.body);
      forceEmailInputsRtl(document);
    }, 2000);
  }

  function boot() {
    try {
      document.documentElement.classList.add('perfyra-hold-signup-popup');
      window.__perfyraCountryReady = false;
    } catch (e) {}

    // Write Beast cookie ASAP (before Doubly finishes loading) so product prices convert.
    var desired = resolveDesiredCurrency();
    if (desired) writeBeastCookie(desired);

    startDoublyLayoutWatcher();
    bindDoublySwitcherSync();
    watchSignupPopupArabic();
    startOfferHoldWatcher();
    startEmailRtlWatcher();
    var roots = document.querySelectorAll('[data-perfyra-country-popup]');
    if (!roots.length) {
      if (desired) keepCurrencyApplied(desired);
      notifyCountryReady();
    } else {
      roots.forEach(initRoot);
      // Safety: never block signup forever (only if country never opened/closed)
      setTimeout(function () {
        if (!window.__perfyraCountryReady && !document.querySelector('.perfyra-country-popup.is-open')) {
          notifyCountryReady();
        }
      }, 120000);
    }
  }

  window.PerfyraCountryPopup = {
    storageKey: STORAGE_KEY,
    setDoublyCurrency: setDoublyCurrency,
    waitForDoublyThenSet: waitForDoublyThenSet,
    submitShopifyCountry: submitShopifyCountry,
    saveChoice: saveChoice,
    isChoiceExpired: isChoiceExpired,
    getSavedChoice: getSavedChoice,
    readDoublyCurrency: readDoublyCurrency,
    pick: pick,
    openPopup: openPopup,
    closePopup: closePopup,
    notifyCountryReady: notifyCountryReady,
    forceHideOfferPopups: forceHideOfferPopups,
    boot: boot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
